import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import DriveFileMoveOutlinedIcon from "@mui/icons-material/DriveFileMoveOutlined";
import DriveFileRenameOutlineOutlinedIcon from "@mui/icons-material/DriveFileRenameOutlineOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import { IconButton } from "@mui/material";
import { Link as RouterLink, useNavigate } from "react-router";
import ActionsMenuButton from "@entrilia/shared/components/ActionsMenuButton";
import type { ArtifactRow } from "./artifactRow";
import { getArtifactEditUrl } from "./artifactUrls";

export interface ArtifactActionHandlers {
  onChangeGroup: (artifactIds: string[], onMoved?: () => void) => void;
  onShare: (artifact: ArtifactRow) => void;
  onDelete: (artifacts: ArtifactRow[], onDeleted?: () => void) => void;
}

interface Props extends ArtifactActionHandlers {
  artifact: ArtifactRow;
  onMenuToggle: (artifactId: string | undefined) => void;
}

const ArtifactActions = ({ artifact, onChangeGroup, onShare, onDelete, onMenuToggle }: Props) => {
  const navigate = useNavigate();

  const select = (action: (artifact: ArtifactRow) => void) => () => {
    onMenuToggle(undefined);
    action(artifact);
  };

  return (
    <>
      <IconButton component={RouterLink} to={getArtifactEditUrl(artifact)} aria-label="Edit">
        <DriveFileRenameOutlineOutlinedIcon />
      </IconButton>
      <ActionsMenuButton
        onOpen={() => onMenuToggle(artifact.id)}
        onClose={() => onMenuToggle(undefined)}
        items={[
          { label: "Edit", icon: <EditOutlinedIcon />, onClick: select((row) => navigate(getArtifactEditUrl(row))) },
          {
            label: "Change Group",
            icon: <DriveFileMoveOutlinedIcon />,
            onClick: select((row) => onChangeGroup([row.id])),
          },
          { label: "Share", icon: <ShareOutlinedIcon />, onClick: select(onShare) },
          {
            label: "Delete",
            icon: <DeleteOutlineOutlinedIcon color="error" />,
            onClick: select((row) => onDelete([row])),
          },
        ]}
      />
    </>
  );
};

export default ArtifactActions;
